module.exports = __webpack_public_path__ + "static/media/plantagambeta.8474939c.webp";